import Typography from "@vapor/react-extended/ExtendedTypography";
import { Button, CircularProgress } from "@vapor/react-material";
import { useTranslation } from "react-i18next";
import type { TaxSubmissionDetailDTO } from "../../../../../../core/api/use-get-tax-submission-detail/TaxSubmissionDetailDTO";
import { useRevokeTaxSubmissions } from "../../../../../../core/api/use-revoke-tax-submissions/useRevokeTaxSubmissions";
import { useSuccessNotification } from "../../../../../../core/hooks/useSuccessNotification";

export const useGetCtaSendRevokeTaxSubmission = (
    onTaxSubmissionUpdate: () => unknown,
    taxPayersToRevoke: { protocol: string; taxId: string }[],
    taxSubmissionDetail: TaxSubmissionDetailDTO,
) => {
    const { t } = useTranslation();

    const { showTextMessage: showSuccessMessage } = useSuccessNotification();
    const { mutateAsync, isPending } = useRevokeTaxSubmissions();

    return (
        <Button
            color="primary"
            disabled={taxPayersToRevoke.length === 0 || isPending}
            onClick={async () => {
                try {
                    await mutateAsync({
                        taxSubmissionId: taxSubmissionDetail.id,
                        taxPayerDocuments: taxPayersToRevoke,
                    });
                    showSuccessMessage(
                        t(
                            "views.home.components.tax_submission_detail_toolbar.primary_cta.send_revoke_tax_submission.actions.revoke.success",
                        ),
                    );
                    onTaxSubmissionUpdate();
                } catch {
                    // error toast already shown via meta.errorMessage in useRevokeTaxSubmissions
                }
            }}
            variant="contained"
        >
            <Typography sx={{ ml: 1 }}>
                {t(
                    "views.home.components.tax_submission_detail_toolbar.primary_cta.send_revoke_tax_submission.actions.revoke.btn",
                )}
            </Typography>

            {isPending && (
                <CircularProgress color="inherit" sx={{ ml: 1 }} size={16} />
            )}
        </Button>
    );
};
